var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{style:(("height: " + _vm.height + "; width: " + _vm.width + ";")),attrs:{"id":("SVG-" + _vm.instanceId),"type":"image/svg+xml","data":_vm.svgPath}})}
var staticRenderFns = []

export { render, staticRenderFns }